import EditorialConfig from '@/EditorialConfig';
import Podcast from '@/types/pages/api/podcasts/Podcast';

const fetchPodcasts = async (): Promise<Podcast[]> => {
    const response: Podcast[] = await fetch(`${EditorialConfig.siteUrl}/api/podcasts`, {
        method: 'GET',
    }).then(r => {
        return r.status === 200 ? r.json() : [];
    });

    return response || [];
};

export default fetchPodcasts;
